import {useState} from 'react';
import { useDispatch } from 'react-redux';
import { addEmployee } from './employeeSlice';

let EmployeeForm=()=>{
    let [formdata, setFormData] = useState({
        employeeId : '',
        firstname : '',
        lastname : '',
        gender : '',
        dob : '',
        mobile : '',
        email : '',
        address : '',
        joiningDate : ''

    })


    const dispatch = useDispatch();

    const handleChange = (e) => {
        setFormData({
          ...formdata,
          [e.target.name]: e.target.value,
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(addEmployee(formdata));
        setFormData({
          employeeId: '',
          firstname: '',
          lastname: '',
          gender: '',
          dob: '',
          mobile: '',
          email: '',
          address: '',
          joiningDate: '',
        });
      };
    
    return (
        <div className="container mt-5">
          <h2 className="mb-4 fw-bold text-center">Add Employee</h2>
          <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-bold">Employee ID</label>
              <input type="text" className="form-control" name="employeeId" value={formdata.employeeId} onChange={handleChange} required />
            </div>
    
            <div className="row mb-3">
              <div className="col">
                <label className="form-label fw-bold">First Name</label>
                <input type="text" className="form-control" name="firstname" value={formdata.firstname} onChange={handleChange} required />
              </div>
              <div className="col">
                <label className="form-label fw-bold">Last Name</label>
                <input type="text" className="form-control" name="lastname" value={formdata.lastname} onChange={handleChange} required />
              </div>
            </div>
    
            <div className="mb-3">
              <label className="form-label fw-bold">Gender</label>
              <select className="form-select" name="gender" value={formdata.gender} onChange={handleChange} required>
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
    
            <div className="row mb-3">
              <div className="col">
                <label className="form-label fw-bold">Date of Birth</label>
                <input type="date" className="form-control" name="dob" value={formdata.dob} onChange={handleChange} required />
              </div>
              <div className="col">
                <label className="form-label fw-bold">Joining Date</label>
                <input type="date" className="form-control" name="joiningDate" value={formdata.joiningDate} onChange={handleChange} required />
              </div>
            </div>
    
            <div className="row mb-3">
              <div className="col">
                <label className="form-label fw-bold">Mobile</label>
                <input type="text" className="form-control" name="mobile" value={formdata.mobile} onChange={handleChange} required />
              </div>
              <div className="col">
                <label className="form-label fw-bold">Email</label>
                <input type="email" className="form-control" name="email" value={formdata.email} onChange={handleChange} required />
              </div>
            </div>
    
            <div className="mb-3">
              <label className="form-label fw-bold">Address</label>
              <textarea className="form-control" name="address" rows="3" value={formdata.address} onChange={handleChange} required />
            </div>
    
            <button type="submit" className="btn btn-primary fw-bold">Submit</button>
          </form>
        </div>
      );
    };
    
    export default EmployeeForm;